import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { OrcamentoService } from './../../../../shared/services/orcamento.service';
import { MessageService } from '../../../../shared/message.service';
import { DICIONARIO_LAUDO_CONTRAN } from '../laudopmmg/laudo-contran.constants';
import { DateService } from '../../../../shared/services/date.service';

@Component({
  selector: 'app-laudopmmg-print',
  templateUrl: './laudopmmg-print.component.html',
  styleUrls: ['./laudopmmg-print.component.css']
})
export class LaudopmmgPrintComponent implements OnInit {
  // Propriedade que receberá o parâmetro via initialState do modal
  protocolo: string=""; 
  
  // Variáveis para armazenar os dados carregados
  dadosLaudo: any;
  classificacao: string="";
  dataGeracao = new Date();
  listaColuna1: any[] = [];
  listaColuna2: any[] = [];
  dataAtual:string="";

  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private rest: OrcamentoService,
    private info: MessageService,
    private dateService: DateService
  ) {
    
    this.dataAtual = this.dateService.getDataAtual();
   }

  dividirLista() {
  const metade = Math.ceil(this.listaParaExibir.length / 2);
  this.listaColuna1 = this.listaParaExibir.slice(0, metade);
  this.listaColuna2 = this.listaParaExibir.slice(metade);
  }

  // Retorna a quantidade total de itens respondidos como 'SIM'
  get totalSim(): number {
    return this.listaParaExibir.filter(item => item.resposta === 'SIM').length;
  }

  // Retorna a quantidade total de itens respondidos como 'NA' ou 'N/A'
  get totalNa(): number {
    return this.listaParaExibir.filter(item => item.resposta === 'NA' || item.resposta === 'N/A').length;
  }

  // Retorna a soma matemática exigida pelo laudo (SIM + NA)
  get totalGeral(): number {
    return this.totalSim + this.totalNa;
  }


  ngOnInit(): void {
    if (this.protocolo) {
      this.carregarDadosRelatorio();
    } else {
      this.info.showErro("Protocolo não identificado para impressão.");
    }
  }
  
  close(): void {
    this.bsModalRef.hide();
  }

  definirClassificacao(laudo: any) {
  if (!laudo) return;

  const tipo = laudo.laudo_tipo;
  
  // Pegamos os totais reais calculados pelos getters que criamos
  const totalSim = this.totalSim;
  const totalGeral = this.totalGeral; // SIM + N/A

  // 1. Regra para Automóvel (Baseado no total de pontos SIM + N/A)
  if (tipo === 'Automóvel') {
    if (totalSim <= 1) this.classificacao = 'Pequena Monta';
    else if (totalSim <= 6) this.classificacao = 'Média Monta';
    else this.classificacao = 'Grande Monta';
  }
  
  // 2. Regra para Motocicleta (Conforme impresso no rodapé da sua imagem)
  else if (tipo === 'Motocicleta' || tipo === 'Motoneta' || tipo === 'Ciclomotor') {
    if (totalSim === 0) {
      this.classificacao = 'Pequena Monta';
    } else if (totalSim >= 1 && totalSim <= 4) {
      this.classificacao = 'Média Monta';
    } else {
      this.classificacao = 'Grande Monta';
    }
  } 
  
  // 3. Regra para Caminhão, Cavalo Mecânico ou Ônibus (Baseado em gravidade 'G' ou qualquer dano)
  else if (tipo === 'Caminhão' || tipo === 'Cavalo Mecânico' || tipo === 'Ônibus') {
    // Procura na lista processada se algum item marcado como SIM possui gravidade 'G'
    const temGrandeMonta = this.listaParaExibir.some(item => item.resposta === 'SIM' && item.valor === 'G');
    
    if (temGrandeMonta) {
      this.classificacao = 'Grande Monta';
    } else if (totalSim > 0) {
      this.classificacao = 'Média Monta';
    } else {
      this.classificacao = 'Pequena Monta';
    }
  } 
  
  // 4. Regra genérica
  else {
    this.classificacao = totalSim > 0 ? 'Média Monta' : 'Pequena Monta';
  }
}



  carregarDadosRelatorio() {
    this.rest.getLaudoPMMG(this.protocolo).subscribe(
      (response: any) => {
        if (response.status === 'success' && response.data?.[0]) {
          this.dadosLaudo = response.data[0];
          this.dividirLista();
          // Aqui você pode aplicar a lógica de classificação se o banco não retornar pronta
          this.definirClassificacao(this.dadosLaudo);
        } else {
          this.info.showErro("Não foi possível localizar os dados do laudo.");
          this.close();
        }
      });
  }


  // No seu componente de impressão
get listaParaExibir(): any[] {
  if (!this.dadosLaudo) return [];
  
  const tipo = this.dadosLaudo.laudo_tipo;
  
  // Resolve a lista base do dicionário (Tratando Cavalo Mecânico como Caminhão)
  const perguntasBase = tipo === 'Cavalo Mecânico'
    ? DICIONARIO_LAUDO_CONTRAN['Caminhão']
    : DICIONARIO_LAUDO_CONTRAN[tipo] || [];

  // Mapeia as respostas vindas do banco (item_1, item_2...) para cada pergunta da lista
  return perguntasBase.map((p, i) => {
    const chaveItem = `item_${i + 1}`;
    return {
      numero: p.item,
      descricao: p.descricao,
      valor: p.valor, // M ou G (será undefined para os outros)
      resposta: this.dadosLaudo[chaveItem] || 'N/A'
    };
  });
}

imprimir() {
  const printContent = document.getElementById('print-section');
  if (!printContent) return;

  const windowUrl = 'about:blank';
  const uniqueName = new Date();
  const windowName = 'Print' + uniqueName.getTime();

  // Abre uma janela temporária
  const printWindow = window.open(windowUrl, windowName, 'left=500,top=500,width=900,height=900');

  if (printWindow) {
    printWindow.document.write(`
      <html>
        <head>
          <title>Relatório Laudo Auto</title>
          <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css">
          
          <style>
            body { background: white !important; padding: 20px; font-family: Arial, sans-serif; }
            .report-paper { padding: 10px; color: black; }
            .table-report th, .table-report td { border: 1px solid black !important; vertical-align: middle; }
            .fw-bold { font-weight: bold !important; }
            .text-uppercase { text-transform: uppercase !important; }
            
            /* Estilo específico para o "X" de marcação */
            .text-center { text-align: center !important; }
            
            .no-print { display: none; }

            /* Ajuste para não cortar o conteúdo em múltiplas páginas */
            @media print {
            .laudo-pmmg td {
                  text-transform: none;
              }
              body { margin: 0; }            
              table { page-break-inside: auto; }
              tr { page-break-inside: avoid; page-break-after: auto; }
              .laudo-pmmg {
                font-size: 10pt;
              }

            }
          </style>
        </head>
        <body>
          ${printContent.innerHTML}
          <script>
            // Aguarda o carregamento dos estilos externos (Bootstrap) antes de imprimir
            window.onload = function() {
              setTimeout(() => {
                window.print();
                window.close();
              }, 300);
            };
          </script>
        </body>
      </html>
    `);

    printWindow.document.close();
  }
}

ngOnDestroy() {
   // console.log('Destroy Filho');
}

}